import {useState} from "react";
import { Client } from "../../types/userManagement";
import {createDefaultAutoCheckInConfig} from "./api";

export function useCreateDefaultCheckInConfig(client: Client | undefined, refetchProfiles: () => void) {

    const [error, setError] = useState<string>()
    const [submitting, setSubmitting] = useState<boolean>()

    const submit = async () => {
        setError(undefined)
        setSubmitting(true)

        const result = await createDefaultAutoCheckInConfig(client)

        result.match(
            () => refetchProfiles(),
            (err) => setError(err.message)
        )

        setSubmitting(false)
    }

    return {submit, submitting, error}

}